import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const ReduceSpending = () => {
  usePageTitle('Reduce Your Spending');
  
  return (
    <div className="page-content">
      <h1 className="page-title">1. Reduce Your Spending</h1>
      <div className="lorem-content">
        <p>
        This is REALLY hard. But without this discipline, the rest of the plan won't amount to much.
        </p>
        <p>
        All of us have a lot of non-discretionary spend: the most common ones being rent or mortgage payments, car instalment payments, gas, utilities and health related costs. You cannot 'cut back' on paying your rent or buying gas for your car. Further, no two people are alike: some of us have long commutes and must spend a lot on gas while others may have high healthcare expenses, perhaps some have kids in college and yet others may be locked into high-interest rate mortgage loans.
        </p>
        <p>
        The "Reduce Spending" really applies therefore to discretionary spend. Take a look at your credit card statement and see what might have been discretionary purchases and evaluate if you can be wiser about them. If you are a sneakerhead or a fashonista or a geek who needs the latest electronics every month or quarter or year, then more power to you. Just realize that any savings you have are a result of what you make minus what you spend. If you don't have a handle on your spending - and can't commit to doing so - then you should probably stop reading now. You can't really change what you earn - at least not in the short-term - and your non discretionary spend is just that: non-discretionary. Your only lever here is to look at your discretionary spend.</p>
        <p>If you have little to no money left after your non-discretionary expenses, then perhaps you aren't at the stage you can invest. This sounds harsh but is a statement of fact. There are a lot of great articles on the net about how to save more money. Read them and see what works for you. Commit to it. And then come back!</p>
        <p>If you're on board with the plan to reduce your spend, let's look at a key component of your non-discretionary spending: <Link to="/lower-your-debt">your debt</Link></p>
      </div>
      <div className="back-link-container">
        <Link to="/steps-to-financial-freedom" className="back-link">
          Back to Steps
        </Link>
      </div>
    </div>
  );
};

export default ReduceSpending; 